module.exports = __webpack_public_path__ + "img/web.53a1d451.png";